import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HiArrowUpTray, HiMagnifyingGlass } from 'react-icons/hi2';
import { PageContent, PageHeader } from '@/components/layout/PageLayout';
import DocumentList from '@/components/documents/DocumentList';
import ErrorBoundary from '@/components/common/ErrorBoundary';

export default function DocumentsPage() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <PageContent $wide>
      <PageHeader
        title={t('documents.title')}
        subtitle={t('documents.subtitle')}
        actions={
          <>
            <Button variant="outline-primary" onClick={() => navigate('/documents/search')}>
              <HiMagnifyingGlass size="1rem" className="me-2" />
              {t('nav.search')}
            </Button>
            <Button variant="primary" onClick={() => navigate('/documents/upload')}>
              <HiArrowUpTray size="1rem" className="me-2" />
              {t('documents.uploadButton')}
            </Button>
          </>
        }
      />
      <ErrorBoundary>
        <DocumentList />
      </ErrorBoundary>
    </PageContent>
  );
}
